import React from "react";
import { TableCell, TableHead, TableRow } from "@material-ui/core";
import locale from "@bonliva-crm/locale";

const rows = [
  { id: "status", numeric: false, label: "", style: { width: 48 } },
  { id: "FirstName", numeric: false, label: locale.FirstName },
  { id: "LastName", numeric: false, label: locale.LastName },
  { id: "SSN", numeric: false, label: locale.SocialSecurityNo },
  { id: "HPR", numeric: false, label: locale.HPRNumber },
  { id: "isApprovedAuthorization", numeric: false, label: locale.CommentAuthorization },
  { id: "Phone", numeric: false, label: locale.Phone },
  { id: "CellPhone", numeric: false, label: locale.CellPhone },
  { id: "Competitor", numeric: false, label: locale.Competitors },
  { id: "Aoe", numeric: false, label: locale.AreaOfExpertise },
  { id: "Address", numeric: false, label: locale.Address },
  { id: "Responsible", numeric: false, label: locale["Responsible BA"] }
];

export function EnhancedTableHead() {
  return (
    <TableHead>
      <TableRow>
        {rows.map((row) => (
          <TableCell key={row.id} align={row.numeric ? "right" : "left"} {...row.style}>
            {row.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
